import React, {Component} from 'react';
import axios from 'axios';
import BookItem from './BookItem';
import Spinner from 'react-bootstrap/Spinner';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props); 
    this.state = { 
      books: [],
      term: 'harry potter',
      searhTerm: 'harry potter',
      url: 'https://www.googleapis.com/books/v1/volumes?q=',
      query: 'harrypotter',
      isLoading: true,
      loadingMsg: 'Loading...',
      noBooksMsg: 'no books found for '
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleClearText = this.handleClearText.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePressEnter = this.handlePressEnter.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.handleSearch(this.state.query);
  }

  handleSearch(query) {
    axios.get(this.state.url + query)
    .then((response) => {
      this.setState({
        books: response.data.items,
        isLoading: false
      });
    })
    .catch(() => {
      this.setState({ message: 'please try again later' });
    });
  }

  handleClearText() {
    this.setState({
      term: ''
    });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  handlePressEnter(e) {
    if(e.key === 'Enter') {
      this.handleSubmit(e);
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.term.trim() === '') {
      alert('Please enter your search term(s)');
      this.setState({
        term: ''
      });
    }
    else {
      const searchQuery = this.state.term.replace(/ /g, '');
      this.setState({
        searhTerm: this.state.term,
        term: '',
        query: searchQuery,
        isLoading: true
      });
      this.handleSearch(searchQuery);
    }
  }

  render() {
    return (
      <div className="App">
        {this.state.isLoading ? (
          <div>
            <Spinner animation="border" role="status" />
            <div>{this.state.loadingMsg}</div>
          </div>
        ) : (
          <div>
            <form onSubmit={this.handleSubmit}>
              <label>Search Term(s): </label>
              <input 
                name="term"
                value={this.state.term}
                onFocus={this.handleClearText}
                onChange={this.handleChange}
                onKeyPress={this.handlePressEnter}
              />
              <button type="submit">Search</button>
            </form>
            {(typeof this.state.books) === 'undefined' ? (
              <div>
                {this.state.noBooksMsg + '\'' + this.state.searhTerm + '\''}
              </div>
            ) : (
              <div>
                <div>Books search for {this.state.searhTerm}</div>
                <table>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Categories</th>
                      <th>Thumbnail</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.books.map((book, index) => {
                      let thumbnail;
                      if (book.volumeInfo.imageLinks) {
                        thumbnail = book.volumeInfo.imageLinks.thumbnail;
                      }
                      return(
                        <BookItem
                          key={index}
                          id={index}
                          title={book.volumeInfo.title}
                          link={book.volumeInfo.previewLink}
                          description={book.volumeInfo.description}
                          categories={book.volumeInfo.categories}
                          thumbnail={thumbnail}
                        /> 
                      );   
                    })}
                    {/* map((book, index) */}
                  </tbody>
                </table>
              </div>
            )} 
            {/* === 'undefined' */}

          </div>
        )}
        {/* this.state.isLoading ? */}

      </div>
    );
  }
}

export default App;
